import { MessagePartPrimitive } from '@assistant-ui/react';
import { MarkdownTextPrimitive } from '@assistant-ui/react-markdown';
import { faHourglass } from '@fortawesome/duotone-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type ComponentProps, type ComponentType, type ElementType, type FC } from 'react';
import './MarkdownText.scss';

type Components = { [Key in Extract<ElementType, string>]?: ComponentType<ComponentProps<Key>> };

const defaultComponents: Components = {
  a: (props) => <a {...props} rel={'noreferrer'} target={'_blank'} />,
};

export const MarkdownText: FC = () => (
  <div className={'chat-text-message box'}>
    <div className={'content'}>
      <MarkdownTextPrimitive className={'chat-markdown-content'} components={defaultComponents} />
      <MessagePartPrimitive.InProgress>
        <span className={'icon chat-running-icon'}>
          <FontAwesomeIcon icon={faHourglass} spin />
        </span>
      </MessagePartPrimitive.InProgress>
    </div>
  </div>
);
MarkdownText.displayName = 'MarkdownText';
